import { format, subDays } from 'date-fns';
import type { EngageReplyLabel } from '@/store/features/engage.feature';

/** The reply labels the Inbox filters on, in the order the filter lists them. */
export const INBOX_LABELS = [
  'interested',
  'objection',
  'referral',
  'not_interested',
  'left_company',
  'unsubscribe',
  'other',
] as const satisfies readonly EngageReplyLabel[];

export type InboxLabel = (typeof INBOX_LABELS)[number];

/** The inbox state that lives in the URL. */
export type InboxSearch = {
  thread?: string;
  view?: 'needs' | 'all' | 'snoozed' | 'archived';
  sequence?: string;
  owner?: string;
  sender?: string;
  since?: 'week' | 'month' | 'quarter';
  label?: InboxLabel | 'none';
};

const SINCE_DAYS = { week: 7, month: 30, quarter: 90 } as const;

/** The day a "since" choice starts on, as the server reads it. */
export function sinceDay(
  since: InboxSearch['since'],
  today = new Date()
): string | undefined {
  if (!since) return undefined;
  return format(subDays(today, SINCE_DAYS[since] - 1), 'yyyy-MM-dd');
}
